import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "basket-line-item-column-image" }
const _hoisted_2 = { class: "basket-line-item-column-description-outer-wrap" }
const _hoisted_3 = { class: "basket-line-item-column-description" }
const _hoisted_4 = { class: "basket-line-item-column-quantity" }
const _hoisted_5 = { class: "basket-line-item-column-price" }

import { InstantProductItem } from '@/storecontext/shared/api/server-apis';
import BasketLineItemQuantity from '@/storecontext/basket/ui/line-items/parts/BasketLineItemQuantity.vue';
import BasketLineItemImage from '@/storecontext/basket/ui/line-items/parts/BasketLineItemImage.vue';
import BasketLineItemRemove from '@/storecontext/basket/ui/line-items/parts/BasketLineItemRemove.vue';
import BasketLineItemPrice from '@/storecontext/basket/ui/line-items/parts/BasketLineItemPrice.vue';
import BasketLineItemSpecs from '@/storecontext/basket/ui/line-items/parts/BasketLineItemSpecs.vue';
import BasketLineItemEdit from '@/storecontext/basket/ui/line-items/parts/BasketLineItemEdit.vue';
import BasketLineItemColliInfo from '@/storecontext/basket/ui/line-items/parts/BasketLineItemColliInfo.vue';
import BasketLineItemTitle from '@/storecontext/basket/ui/line-items/parts/BasketLineItemTitle.vue';
import ItemMessages from '@/storecontext/shared/checkout/ui/ItemMessages.vue';
import BasketLineItemSelectDiscount from '@/storecontext/basket/ui/line-items/parts/BasketLineItemSelectDiscount.vue';
import BasketLineItemUpSell from '@/storecontext/basket/ui/line-items/parts/BasketLineItemUpSell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemInstant',
  props: {
    item: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BasketLineItemImage, {
        sku: __props.item.sku,
        alt: __props.item.name,
        version: __props.item.imageVersion,
        "link-url": __props.item.links?.productUrl
      }, null, 8, ["sku", "alt", "version", "link-url"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BasketLineItemTitle, {
          title: __props.item.name,
          "link-url": __props.item.links?.productUrl
        }, null, 8, ["title", "link-url"]),
        _createVNode(BasketLineItemColliInfo, {
          multiplier: __props.item.quantityMultiplier
        }, null, 8, ["multiplier"]),
        _createVNode(BasketLineItemSpecs, {
          specs: __props.item.specifications
        }, null, 8, ["specs"]),
        _createVNode(BasketLineItemEdit, {
          "link-url": __props.item.links?.editProductUrl
        }, null, 8, ["link-url"]),
        _createVNode(ItemMessages, {
          messages: __props.item.secondaryItemMessages,
          class: "basket-line-item-messages"
        }, null, 8, ["messages"])
      ]),
      _createVNode(BasketLineItemUpSell, {
        "item-id": __props.item.id
      }, null, 8, ["item-id"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BasketLineItemQuantity, {
        id: __props.item.id,
        quantity: __props.item.quantity,
        multiplier: __props.item.quantityMultiplier
      }, null, 8, ["id", "quantity", "multiplier"]),
      _createVNode(BasketLineItemRemove, {
        id: __props.item.id
      }, null, 8, ["id"]),
      _createVNode(ItemMessages, {
        messages: __props.item.primaryItemMessages,
        class: "basket-line-item-messages"
      }, null, 8, ["messages"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BasketLineItemSelectDiscount, {
        id: __props.item.id
      }, null, 8, ["id"]),
      _createVNode(BasketLineItemPrice, {
        price: __props.item.price,
        quantity: __props.item.quantity
      }, null, 8, ["price", "quantity"])
    ])
  ]))
}
}

})